export const SET_COMPANY_NAME = 'SET_COMPANY_NAME';
export const SET_COMPANY_TOKEN = 'SET_COMPANY_TOKEN';
export const SET_COMPANY_NON_US_INTERNATIONALIZATION_ENABLED =
  'SET_COMPANY_NON_US_INTERNATIONALIZATION_ENABLED';

export function setCompanyName(name) {
  return {
    type: SET_COMPANY_NAME,
    payload: name,
  };
}

export function setCompanyToken(token) {
  return {
    type: SET_COMPANY_TOKEN,
    payload: token,
  };
}

export function setCompanyNonUsInternationalizationEnabled(enabled) {
  return {
    type: SET_COMPANY_NON_US_INTERNATIONALIZATION_ENABLED,
    payload: !!enabled,
  };
}
